<template>
  <nav
    class="px-lg-4 navbar navbar-expand d-flex flex-wrap dis_justify-content-between align-items-center py-2 px-3 mb-3"
  >
    <router-link class="navbar-brand order-1 p-0" :to="{ name: 'home' }">
      <img :src="props.logo" alt="Logo" style="max-height: 40px; max-width: 250px" />
      <div v-if="userStore.connectedUser?.environment && userStore.connectedUser?.environment != 'Production'" class="badge ms-3 text-bg-warning">{{ userStore.connectedUser.environment }}</div>
    </router-link>

    <div class="collapse navbar-collapse justify-content-center order-3 order-sm-2" id="navbarSupportedContent">
      <ul class="navbar-nav d-flex flex-wrap">
        <li class="nav-item text-nowrap" v-if="router.currentRoute.value.name !== 'home'">
          <router-link :to="{ name: 'home' }" class="nav-link m-2 my-2 my-md-0 p-0">Accueil</router-link>
        </li>
        <!-- <li class="nav-item text-nowrap">
          <router-link :to="{ name: 'profile' }" class="nav-link m-2 my-2 my-md-0 p-0">Mon Profil</router-link>
        </li> -->
        <li class="nav-item text-nowrap" v-if="userStore.currentUser?.isAdmin">
          <router-link :to="{ name: 'admin' }" class="nav-link m-2 my-2 my-md-0 p-0">Admin</router-link>
        </li>
        <li class="nav-item text-nowrap" v-if="userStore.currentUser?.isAdmin">
          <router-link :to="{ name: 'travel-board' }" class="nav-link m-2 my-2 my-md-0 p-0">Board</router-link>
        </li>
      </ul>
    </div>
    <div class="text-end d-flex align-items-center gap-2 ms-auto order-2 order-sm-3">
      <router-link v-if="userStore.connectedUser" :to="{ name: 'profile' }" class="text-decoration-none text-body small d-none d-md-block">
        {{ userStore.connectedUser.firstName }} {{ userStore.connectedUser.lastName?.toUpperCase() }}
      </router-link>
      <a href="#" v-if="pwaElligible" @click.prevent="pwaInstall" title="Installer MyNemo">
        <span class="fa-stack">
          <i class="fa-regular fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-plus fa-stack-1x"></i>
        </span>
      </a>
      <a href="#" @click.prevent="handleLogout" title="Déconnexion">
        <span class="fa-stack">
          <i class="fa-regular fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-right-from-bracket fa-stack-1x"></i>
        </span>
      </a>
      <a href="mailto:mynemo@nemoprod.fr" target="_blank" title="Contacter l'équipe Nemo">
        <span class="fa-stack">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-regular fa-envelope fa-stack-1x fa-inverse"></i>
        </span>
      </a>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { usePwaInstall } from "@/compositions/usePwaInstall"

const userStore = useUserStore()
const router = useRouter()
const { install: pwaInstall, elligible: pwaElligible } = usePwaInstall()

const handleLogout = async () => {
  await userStore.logout()
  router.push('/')
}

const props = withDefaults(defineProps<{
  logo?: string
}>(), {
  logo: new URL(`/src/assets/logo.png`, import.meta.url).href
})

</script>

<style lang="css">

</style>
